import React, {ChangeEventHandler, forwardRef, InputHTMLAttributes} from 'react'

import cn from 'classnames/bind'

import s from './Checkbox.module.scss'
import {IFieldBase} from '../Input/Input'

const cx = cn.bind(s)

export interface ICheckboxProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value'>,
		IFieldBase {
	className?: string
	classNameLabel?: string
	classNameWrapper?: string
	value: boolean | undefined
	onChange?: ChangeEventHandler<HTMLInputElement> | undefined
	showError?: boolean
	showRequired?: boolean
	disabled?: boolean
}

const Checkbox = forwardRef<HTMLInputElement, ICheckboxProps>(
	(
		{
			className,
			classNameLabel,
			classNameWrapper,
			label,
			error,
			showError = true,
			showRequired = true,
			disabled,
			value: isChecked,
			...props
		},
		ref,
	) => {
		return (
			<div className={cx('wrapper', {isError: !!error, disabled}, classNameWrapper)}>
				<label className={cx('label', classNameLabel)}>
					<input
						className={cx('input', className)}
						type="checkbox"
						checked={isChecked}
						{...props}
						ref={ref}
					/>
					<span className={s.inner} data-testid="check">
						{<Check />}
					</span>
					<span className={cx('text', 'global-label-text')}>
						{label}&nbsp;{props.required && showRequired && <span className={cx('star')}>*</span>}{' '}
					</span>
				</label>

				{!!error && showError && <p className={s.error}>{error}</p>}
			</div>
		)
	},
)

Checkbox.displayName = 'Checkbox'

export default Checkbox

const Check = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="16" height="16" rx="2" fill="#F89220" />
		<rect
			x="3"
			y="7.31253"
			width="1.9445"
			height="6.48167"
			rx="0.972251"
			transform="rotate(-45 3 7.31253)"
			fill="white"
		/>
		<rect
			x="12.625"
			y="4.10428"
			width="1.9445"
			height="9.07434"
			rx="0.972251"
			transform="rotate(45 12.625 4.10428)"
			fill="white"
		/>
	</svg>
)
